import TWEEN from "@tweenjs/tween.js"

const animateCamera = (camera, controls, cameraSettings) => {
  // console.log("animatingCam");
  // console.log("camera", camera);
  // console.log("controls", controls);
  // console.log("cameraSettings", cameraSettings);
  const { position, target, duration } = cameraSettings
  controls.enabled = false
  const from = {}
  const to = {}

  if (position) {
    from.px = camera.position.x
    from.py = camera.position.y
    from.pz = camera.position.z
    to.px = position.x
    to.py = position.y
    to.pz = position.z
  }
  // console.log("from::", from);

  if (target) {
    from.tx = controls.target.x
    from.ty = controls.target.y
    from.tz = controls.target.z
    to.tx = target.x
    to.ty = target.y
    to.tz = target.z
  }

  return new TWEEN.Tween(from)
    .to(to, duration ?? 5000)
    .easing(TWEEN.Easing.Sinusoidal.InOut)
    .onUpdate(function ({ px, py, pz, tx, ty, tz }) {
      if (px != null) {
        camera.position.set(px, py, pz)
      }
      if (tx != null) {
        // console.log(controls.target);
        controls.target.set(tx, ty, tz)
      }
      // controls.update();
    })
    .onComplete(() => {
      controls.enabled = true
      console.log("COMPLETE")
    })
    .start()
}

export default animateCamera

// import { useFrame, useThree } from "@react-three/fiber";
// import { memo, useState } from "react";
// import * as TWEEN from "@tweenjs/tween.js";
// import { useStore } from "../State/Store";

// const animateCamera = (camera, controls, cameraSettings) => {
//   console.log("camera", camera);
//   console.log("controls", controls);
//   console.log("cameraSettings", cameraSettings);
//   const { position, target, duration } = cameraSettings;
//   controls.enabled = false;
//   const from = {};
//   const to = {};

//   if (position) {
//     from.px = camera.position.x;
//     from.py = camera.position.y;
//     from.pz = camera.position.z;
//     to.px = position.x;
//     to.py = position.y;
//     to.pz = position.z;
//   }
//   if (target) {
//     from.tx = controls.target.x;
//     from.ty = controls.target.y;
//     from.tz = controls.target.z;
//     to.tx = target.x;
//     to.ty = target.y;
//     to.tz = target.z;
//   }

//   return new TWEEN.Tween(from)
//     .to(to, duration ?? 5000)
//     .easing(TWEEN.Easing.Sinusoidal.InOut)
//     .onUpdate(function ({ px, py, pz, tx, ty, tz }) {
//       // console.log(px);

//       if (px != null) {
//         camera.position.set(px, py, pz);
//       }
//       if (tx != null) {
//         controls.target.set(tx, ty, tz);
//       }
//     })
//     .onComplete(() => {
//       controls.enabled = true;
//       console.log("COMPLETE");
//     })
//     .start();
// };

// function AniamteCamera() {
//   const [animating, setAnimating] = useState(true);
//   // const { camera } = useThree();

//   const coords = {
//     x: wide.x,
//     y: wide.y,
//     z: wide.z,
//   };
//   const tween1 = new TWEEN.Tween(coords)
//     .to({ x: close.x, y: close.y, z: close.z }, 1000)

//     .onUpdate(() => {
//       // console.log(camera.position.x);
//       // console.log(coords.x);se
//     })

//     .start();

//   tween1.onComplete(function () {
//     setAnimating(false);
//     console.log("done!");
//   });

//   useFrame((state) => {
//     // console.log(coords.x);
//     console.log(state.camera.position.x);

//     if (animating) state.camera.position.x = coords.x;
//     // console.log(state.camera.position.x);

//     TWEEN.update();

//     // console.log(x);
//   }, []);

//   return null;
// }

// export default animateCamera;
